export const StepNames = {
  YOUR_BUSINESS: 'Your Business',
  PAYMENTS: 'Payments',
  BUSINESS_DETAILS: 'Business Details',
  BUSINESS_IDS: 'Business Ids',
  BUSINESS_ADDRESS: 'Business Address',
  YOUR_DETAILS: 'Your Details',
  ORDER_SUMMARY: 'Order Summary',
  DASHBOARD: 'Dashboard',
  BANKING_DETAILS: 'Banking Details',
  YOUR_DETAILS_SELFIE: 'Selfie',
  UPLOAD_DOCUMENTS: 'Upload documents',
  CUSTOMER_ADDRESS: 'Customer Address',
  CONFIRM_APPLICATION: 'Confirm Application',
};
